import { useEffect, useRef, useState } from 'react'
import { Check } from 'lucide-react'
import useTaskStore from '../store/taskStore'
import { useT } from '../i18n/useT'

export default function SyncToast() {
  const t       = useT()
  const syncing = useTaskStore(s => s.syncing)
  const [visible, setVisible] = useState(false)
  const [done,    setDone]    = useState(false)
  const timerRef = useRef(null)

  useEffect(() => {
    if (syncing) {
      clearTimeout(timerRef.current)
      setDone(false)
      setVisible(true)
    } else if (visible) {
      setDone(true)
      timerRef.current = setTimeout(() => setVisible(false), 1500)
    }
    return () => clearTimeout(timerRef.current)
  }, [syncing])

  if (!visible) return null

  return (
    <div className={`sync-toast${done ? ' sync-toast--done' : ''}`}>
      {done
        ? <span className="sync-toast__icon"><Check size={14} strokeWidth={3} /></span>
        : <span className="sync-toast__spinner" />
      }
      <span>{done ? t('sync_done') : t('sync_syncing')}</span>
    </div>
  )
}
